import React from "react";
import { useEffect } from "react";
import InputForm from "../../../Components/InputForm/InputForm";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import "./PersonalDetailsView.css";
import {
  insertUpdateWitnessdetails,
  getWitnessDeatilsByMemberId,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import validator from "validator";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { ApplicationStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";
const WitnessDetails = (props) => {
  // const { state } = useLocation();
  const location = useLocation();
  const [data, setData] = React.useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobileNumber: null,
    email: "",
    address: "",
  });
  const [disable, setDisabled] = React.useState(true);
  // const memberid =
  //   GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";

  // const memberid = state.id ? state.id : "";
  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) { // || params.has("hide")
        let encMemberId = params.get("memberid");
        // let memberid = decodeURIComponent(Decrypt(encMemberId));
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split('||');
        let memberid = parts[0];
        // let hide = params.get("hide");
        getWitnessDetails(memberid);
      }
    }
  }, [location.search]);
  // React.useEffect(() => {
  //   getWitnessDetails();
  // }, []);
  const getWitnessDetails = async (memberid) => {
    let param = `${getWitnessDeatilsByMemberId}`;
    let requestBody = { MemberId: memberid };
    const insertData = await APICall(param, requestBody);
    if (insertData.Data != null) {
      let data = {
        firstName: insertData.Data.FirstName,
        middleName: insertData.Data.MiddleName,
        lastName: insertData.Data.LastName,
        mobileNumber: insertData.Data.ContactNo,
        email: insertData.Data.EmailId,
        address: insertData.Data.Address,
      };
      setData(data);
    }
    return insertData.Data;
  };
  return (
    <div className="">
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>First Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.firstName}
              isDisabled={disable}
              maxLength={30}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Middle Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.middleName}
              isDisabled={disable}
              maxLength={30}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Last Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.lastName}
              isDisabled={disable}
              maxLength={30}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Mobile Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.mobileNumber}
              type="number"
              maxlength={10}
              isDisabled={disable}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <InputForm
              placeholder={""}
              value={data.email}
              isDisabled={disable}
              maxLength={50}
            />
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>

            <label>Address</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.address}
              textArea={true}
              maxlength={200}
              isDisabled={disable}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WitnessDetails;
